/**
 * Environment variables configuration for Verity application
 * These variables are replaced at deployment time using Katal webpack plugin
 */

// Environment variables object
const ENVIRONMENT_VARIABLES = Object.freeze({
  env: {
    // Base configuration
    Region: 'us-west-2',
    Stage: 'alpha',
    BuildTime: '9/24/2026, 3:36:26 PM',
    AwsAccountId: '121838513191',
    VerityUser: 'jamagarg',

    // CloudFront configuration
    CloudFrontProtocol: 'https',
    CloudFrontDomain: 'd16s6nn4muxg7e.cloudfront.net',
    ApplicationDomain: 'jamagarg.alpha.verity.device.finance.amazon.dev',

    // Authentication configuration
    CognitoUserPoolId: 'us-west-2_03Fd9D4Sg',
    CognitoUserPoolWebClientId: '3l0areig9h96umcf0lg5t534sc',
    CognitoIdentityPoolId: 'us-west-2:92e8157d-1c71-429c-84fb-56521045f440',
    CognitoDomain: 'verity-application-alpha.auth.us-west-2.amazoncognito.com',
    AuthRoleARN: 'arn:aws:iam::121838513191:role/DasFintechVerityCognito-S-CognitoAuthenticatedRole5-k7OuZMcr0Rit',
    UnAuthRoleARN: 'arn:aws:iam::121838513191:role/DasFintechVerityCognito-S-CognitoUnauthenticatedRol-WYaUNuJ1JaWY',

    // Monitoring and logging
    RumAppMonitorId: 'e8275eb1-7d13-49ac-9093-43fb8b17d474',
    LoggerUrl: 'https://logger-alpha.verity.device.finance.amazon.dev/v1/log',
    MetricsUrl: 'https://monitoring-alpha.verity.device.finance.amazon.dev/v1/monitoring',

    // Dashboard registry
    DashboardsTableName: 'verity-dashboards-alpha',

    // SNS topic for attribute notifications (forwarded to Slack via AWS Chatbot)
    SnsNotificationARN: 'arn:aws:sns:us-west-2:121838513191:verity-attribute-notifications-alpha',

    // Bedrock config for AI-assisted attribute matching. The matcher attaches
    // its OWN guardrail (VerityAttributeMatcherGuardrail — no PROMPT_ATTACK
    // filter, which would otherwise block the catalog-heavy prompt). The
    // guardrail is MANDATORY: the Cognito auth-role IAM policy denies any
    // InvokeModel call that does not attach one of our guardrails. Replaced at
    // deploy time from the CDK (AuthParams -> deploymentTimeReplacements).
    BedrockModelId: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
    BedrockMatcherGuardrailId: 'z78gvfqj79wy',
    BedrockMatcherGuardrailVersion: '1',
  },
});

export default ENVIRONMENT_VARIABLES;
